import * as angular from 'angular';
import {IHttpService, IPromise, IHttpPromise} from 'angular';
import TSSerfProperty from '../../models/TSSerfProperty';

export class SerfPropertyRS {
    serviceURL: string;
    http: IHttpService;

    static $inject = ['$http', 'REST_API'];
    /* @ngInject */
    constructor($http: IHttpService, REST_API: string) {
        this.serviceURL = REST_API + 'serf-properties';
        this.http = $http;

    }

    getByName(name: string): IPromise<TSSerfProperty> {
        return this.http.get(this.serviceURL + '/key/' + encodeURIComponent(name), {cache: true}).then((response) => {
            return <TSSerfProperty>response.data;
        });
    }

    create(name: string, value: string | undefined): IPromise<TSSerfProperty> {
        return this.http.post(this.serviceURL + '/' + encodeURIComponent(name), value, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then((response: any) => {
            return new TSSerfProperty().deserialize(response.data);
        });
    }

    update(name: string, value: string | undefined): IPromise<TSSerfProperty> {
        return this.http.post(this.serviceURL + '/' + encodeURIComponent(name), value, {
            headers: {
                'Content-Type': 'text/plain'
            }
        }).then((response: any) => {
            return new TSSerfProperty().deserialize(response.data);
        });
    }

    remove(name: string): IHttpPromise<any> {
        return this.http.delete(this.serviceURL + '/' + encodeURIComponent(name));
    }

    getAllSerfProperties(): IPromise<TSSerfProperty[]> {
        return this.http.get(this.serviceURL + '/', {cache: true}).then((response: any) => {
            let converter = (jsonString: any) => {
                return new TSSerfProperty().deserialize(jsonString);
            };
            if (angular.isArray(response.data)) {
                return response.data.map(converter);
            }
            return [];
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/admin/service/serfPropertyRS.rest.ts